<style lang="scss" scoped>
.form-element {
  position: relative;
  width: 100%;
  display: flex;
  border: 1px solid $c-dark-grey;
  margin-top: 9px;

  label {
    display: block;
    border-right: 1px solid $c-dark-grey;
    padding: 10px 15px;
    text-align: right;
    height: 100%;
    background: $c-off-white;
  }
  // label {
  //   transition: all 0.2s;
  //   position: absolute;
  //   transform: translate(0, 0);
  //   padding-left: 4px;
  //   padding-right: 4px;
  //   opacity: 0;
  //   top: -3px;
  //   //color: $c-white;
  //   background: none;
  //   left: -13px;
  //   text-transform: none;
  //   font-weight: 700;
  //   font-size: 11px;
  //   letter-spacing: 1px;
  // }

  // label.hasvalue {
  //   transform: translate(10px, -9px);
  //   opacity: 1;
  // }
  input {
    padding: 10px 15px;
    filter: none;
    //background-color: transparent !important;
    background: #fff;

    display: block;
    width: 100%;

    //border-top: 2px solid $c-white;
    //border-bottom: 2px solid $c-white;
    border: 0;
    //color:#fff;
    letter-spacing: 1px;
    //font-weight: 700;
    &:focus {
      box-shadow: 0 0 10px rgba(0, 0, 0, 0.3);
      outline: none;
    }

    // &:hover {
    //   background-color: $c-light-blue;
    // }
  }

  input:-webkit-autofill,
  input:-webkit-autofill:hover,
  input:-webkit-autofill:focus,
  textarea:-webkit-autofill,
  textarea:-webkit-autofill:hover,
  textarea:-webkit-autofill:focus,
  select:-webkit-autofill,
  select:-webkit-autofill:hover,
  select:-webkit-autofill:focus {
    -webkit-box-shadow: 0 0 0px 0px $c-blue inset;
    transition: background-color 5000s ease-in-out 0s;
    -webkit-text-fill-color: $c-dark-grey !important;
  }
}
</style>

<template>
  <div class="form-element">
    <label for="role" :class="{ hasvalue: model && model != '' }" v-if="label != ''">{{ label }}</label>
    <input :type="type" v-model="model" @focus="emit('focus')" />
  </div>
</template>

<script lang="ts">
import { defineComponent, computed } from 'vue';

export default defineComponent({
  props: {
    type: { type: String, default: 'text' },
    label: { type: String, default: '' },
    modelValue: String,
  },
  emits: ['focus', 'update:modelValue'],
  setup(props, { emit }) {
    const model = computed({
      get: () => props.modelValue,
      set: (id: any) => emit('update:modelValue', id),
    });

    const onChange = (value: string) => {
      model.value = value;
    };

    return {
      model,
      onChange,
      emit,
    };
  },
});
</script>
